module.exports = __webpack_public_path__ + "static/05-311a33325996da81d86a6cd4221694e4.jpg";